import { gql } from '@apollo/client';

import {
  ReportProblemDocument,
  type ReportProblemMutation,
  type ReportProblemMutationVariables,
} from '../__generated__/documents';

if (false) {
  gql`
    mutation ReportProblem($input: ReportProblemInput!) {
      reportProblem(input: $input)
    }
  `;
}

export const REPORT_PROBLEM = ReportProblemDocument;
export type { ReportProblemMutation, ReportProblemMutationVariables };
